import { Form, Input } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import SensitiveInput from '../SensitiveInput'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['TurnstileSiteKey', 'TurnstileSecretKey']

export default function TurnstileSection({ options }: { options: OptionsAPI }) {
  const { get, patch } = options

  return (
    <SettingSectionCard title="Turnstile" subtitle="Cloudflare Turnstile 人机验证密钥" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="Site Key">
            <Input value={get('TurnstileSiteKey')} onChange={(v) => patch({ TurnstileSiteKey: v })} />
          </Form.Item>
          <Form.Item label="Secret Key">
            <SensitiveInput value={get('TurnstileSecretKey')} onChange={(v) => patch({ TurnstileSecretKey: v })} />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
